import * as React from 'react';
import {
    DataGrid,
    GridColDef,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridRenderCellParams,
    GridValueGetterParams,
} from '@mui/x-data-grid';
import { Avatar, Box, Popover, Typography } from '@mui/material';
import { IState } from '../../../../../redux/reducers/rootReducers';
import { connect } from 'react-redux';
import { ITicket } from '../../../../../redux/actions/TicketsManagement/TicketsManagement';
import { ContactPopover } from '../../../../TicketManagementSystem/Modules/TicketCard';
import { ConvertZ } from '../../../../helpers/helperFunctions';
import timeSpanToReadableFormat from '../../../../../util/timeSpanToReadbleFormat';
import TicketActionsNew from '../../TicketActionNew';
import { updateAgentPreference } from '../../../../../redux/actions/userManagement/agents';

function CustomToolbar({ handleSetrue}:any) {
    const handleColumnClick = () => {
         handleSetrue()
    window.scrollTo({ top: 0, behavior: "smooth" });
    const gridContainer = document.querySelector(".MuiDataGrid");
    if (gridContainer) {
      gridContainer.scrollTop = 0;
    }
    const toolbarContainer  = document.querySelector(".toolbarContainer");
    if (toolbarContainer ) {
      toolbarContainer .scrollTop = 0;
    }
    const gridScroller = document.querySelector(".MuiDataGrid-virtualScroller");
    
  if (gridScroller) {
    gridScroller.scrollTo({ top: 0, behavior: "smooth" });
  }
  };
    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton   sx={{ zIndex: 1300 }} onClick={handleColumnClick} />
        </GridToolbarContainer>
    );
}

interface ListViewTableProps {
    tickets: ITicket[];
    currAgent : any;
    dispatch: React.Dispatch<any>;
    handleSetrue:any,handleScroll :any
}

const ListViewTable: React.FC<ListViewTableProps> = ({ tickets, currAgent,  dispatch,   handleSetrue,handleScroll }) => {

    const bindData = (params: GridRenderCellParams|any) => {
        const value = params.field.split('.').reduce((acc: any, key: string) => acc?.[key], params.row);
        
        if (params.colDef.isDateField) {
            if (!value) return '—';
            const date = ConvertZ(value);
            return date ?? "-";
        }
        if (params.colDef.isPriorityField) {
            return <Typography component={"span"}       sx={(theme) => ({
        color:
          theme.palette.mode === "dark"
            ? "white"
            : params.row.ticketLogs?.priority?.color || "inherit",
      })}>{value ?? "-"}</Typography>;
        }
        if (params.colDef.isSLAField) {
            const formattedSLA:string = timeSpanToReadableFormat(value, "ss");
            const color = formattedSLA.includes("-") ? "red" : "green";
            return <Typography component={"span"}  sx={(theme) => ({
        color:
          theme.palette.mode === "dark"
            ? (color === "red" ? "#ffb6c1" : "#1dcd9f")
            : color|| "inherit",
      })}> {formattedSLA || "NO SLA"}</Typography>;
        }
        
        return value ?? '—';
    };

    const getValue = (params:GridValueGetterParams|any) => {
       const value = params.field.split('.').reduce((acc: any, key: string) => acc?.[key], params.row);
        if (params.colDef.isDateField) {
            if (!value) return '—';
            return new Date(value).getTime();
        }
        if (params.colDef.isSLAField) {
            return params.row.ticketLogs.slaRemainingInTicks||0;
        }
       
       return value ?? '—';
    }

    const getContactBox = (params: GridRenderCellParams) => {
        return (<><GetContactBox {...params}/></>);
    }

    const bindActions = (params: GridRenderCellParams) => {
        const { row } = params;
        return (
        <Box className="rightAlignedActions">
            <TicketActionsNew ticketData={row}/>
        </Box>)
    }

    const bindIdColumn = (params: GridRenderCellParams) => {
        return (
            <Typography 
                onClick={()=>{
                    dispatch({
                          type: "TICKET_VIEW_INFO",
                          payload: {ticketId:params.row.id,type:"quick-update"},
                        });
                    }} 
                component={"span"} 
                className='pointer'
            > 
                {params?.row?.id}
            </Typography>
        );
    }
    
    
    const columns: GridColDef[] = [
        {
            field: 'id',
            headerName: 'ID',
            renderCell: bindIdColumn,
            valueGetter: getValue,
            flex: 1,
        },
         {
            field: 'actions',
            headerName: 'Actions',
            sortable: false,
            minWidth : 180,
            filterable: false,
            disableColumnMenu: true,
            renderCell: bindActions,
            flex: 1,
        },
        {
            field: 'ticketLogs.contacts.knownAs',
            headerName: 'Contact',
            renderCell: getContactBox,
            valueGetter: getValue,
            sortable: true,
            minWidth: 90,
            flex: 1,
        },
       
    ];

    const additionalColumns: GridColDef[] = Object.entries(schema).map(([key, value]) => ({
        field: key,
        headerName: value.headerName,
        sortable: value.sortable,
        isSLAField: value.isSLAField || false,
        isDateField: value.isDateField || false,
        isPriorityField : value.isPriorityField || false,
        minWidth: value?.width || 150,
        flex: 1,
        valueGetter: getValue,
        renderCell:bindData
    }));

    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState(currAgent.agentPreferences ? JSON.parse(currAgent.agentPreferences).listViewColumnVisibility : {});
    const handleColumnVisibilityChange = (newModel:any) => {
        setColumnVisibilityModel(newModel);
    };
    React.useEffect(() => {
        localStorage.setItem('listViewColumnVisibility', JSON.stringify(columnVisibilityModel));
        console.log("cleanupListView", columnVisibilityModel);
    }, [columnVisibilityModel]);
    // React.useEffect(() => {
    //     return(()=>{
    //         const cleanupListView = localStorage.getItem('listViewColumnVisibility') || "{}";
    //         console.log("cleanupListView", cleanupListView);
    //         localStorage.removeItem('listViewColumnVisibility');
    //         dispatch(updateAgentPreference("listViewColumnVisibility", JSON.parse(cleanupListView)));
    //     });
    // }, []);
    const wasPanelOpen = React.useRef(false);
    
    const handleStateChange = (state: { preferencePanel: { open: any; }; }) => {
    const isPanelOpen = !!state.preferencePanel?.open;

    // Detect when column panel closes
    if (wasPanelOpen.current && !isPanelOpen) {
      const cleanupListView = localStorage.getItem("listViewColumnVisibility") || "{}";
      console.log("cleanupListView", cleanupListView);
      localStorage.removeItem("listViewColumnVisibility");
      dispatch(updateAgentPreference("listViewColumnVisibility", JSON.parse(cleanupListView)));
    }

    wasPanelOpen.current = isPanelOpen;
  };
    return (
        <Box sx={{height: 'auto',  zIndex:1, }}>
           <DataGrid
    columnVisibilityModel={columnVisibilityModel}
    onColumnVisibilityModelChange={handleColumnVisibilityChange}
    className="ticketListViewTable"
    rows={tickets}
    onStateChange={handleStateChange}
    columns={columns.concat(additionalColumns)}
    checkboxSelection={false}
    disableRowSelectionOnClick
    components={{
        Toolbar:()=> CustomToolbar({handleSetrue}),
    }}
    componentsProps={{
        panel: {
            sx: {
                zIndex: 1300, // MUI modal z-index is 1300 by default
            },
        },
    }}
    autoHeight
    sx={(theme) => ({
        backgroundColor: 'inherit',
        '& .MuiDataGrid': {
            height: '54vh',
            zIndex: 1,
        },
        '& .MuiDataGrid-toolbarContainer': {
            position: 'fixed',
            zIndex: 10, // Increased z-index for toolbar
            backgroundColor: theme.palette.mode === "dark"
                ? "#4a4a4e"
                : "#F0F3FE",
            width: '93vw',
            mb: 10,
        },
        '& .MuiDataGrid-columnHeaders': {
            position: 'fixed',
            width: '93vw',
            zIndex: 9, // Lower than toolbar but higher than content
            mt: 4,
            backgroundColor: theme.palette.mode === "dark"
                ? "#4a4a4e"
                : "#F0F3FE",
        },
        '& .MuiDataGrid-virtualScroller': {
            mt: 10,
            overflowY: 'auto !important',
        },
        '& .MuiDataGrid-footerContainer': {
            position: 'sticky',
            bottom: -5,
            backgroundColor: theme.palette.mode === "dark"
                ? "#4a4a4e"
                : "#F0F3FE",
            zIndex: 8,
        },
        // Ensure column panel appears above everything
        '& .MuiDataGrid-columnsPanel': {
            zIndex: 1300,
        },
          '& .MuiDataGrid-panel': {
            position: 'fixed !important',
            top: '0px', // adjust based on your toolbar height
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1300,
            backgroundColor:
            theme.palette.mode === 'dark' ? '#4a4a4e' : '#fff',
            boxShadow: theme.shadows[5],
  },
    })}
/>

        </Box>
    );
}

const GetContactBox = (params: GridRenderCellParams) => {
    const contact = params?.row?.ticketLogs?.contacts || {};
    const secondaryContact = params?.row?.ticketLogs?.secondaryContacts || {};

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'contact-popover' : undefined;


    return (
        <Box className="imgBox">
            <Box>
                <button
                    type="button"
                    onClick={handleClick}
                    style={{ background: "none", border: "none", padding: 0, margin: 0, cursor: "pointer" }}
                >
                    <Avatar
                        className="sml-avatar"
                        sx={{ height: 25, width: 25 }}
                        alt={contact?.name || "PP"}
                        src={`${contact?.profilePicturePath || ""}`}
                    />
                </button>

                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Box sx={{ p: 1 }}>
                        <ContactPopover contactInfo={contact} secContactInfo={secondaryContact} />
                    </Box>
                </Popover>
            </Box>
        </Box>
    );
}


interface ColumnSchema extends Omit<GridColDef, 'field'> {
  isDateField?: boolean;
  isSLAField?: boolean;
  width?: number;
  isPriorityField?: boolean;
}

const schema: Record<string, ColumnSchema>  = { 
    "ticketLogs.contacts.name" : { "headerName": "Contact Name","sortable": true },
    "ticketLogs.contacts.contactOrganisation.name" : { "headerName": "Organisation",  "sortable": true },
    "ticketLogs.title" : { "headerName": "Subject", "width" : 300 , "sortable": true },
    "ticketLogs.ticketStatus.displayName" : { "headerName": "Status", "sortable": true },
    "ticketLogs.ticketType.displayName" : { "headerName": "Ticket Type", "sortable": true },
    "ticketLogs.group.name" : { "headerName": "Group", "sortable": true },
    "ticketLogs.agent.fullName" : { "headerName": "Agent", "sortable": true },
    "createdDateTime" : { "headerName": "Created Date", "isDateField" : true, "sortable": true },
    "ticketLogs.dueDateTime" : { "headerName": "Due Date", "width" : 200, "isDateField" : true, "sortable": true },
    "ticketLogs.createdDateTime" : { "headerName": " Last Updated Date", "isDateField" : true, "sortable": true },
    "ticketLogs.priority.name" : { "headerName": "Priority", "sortable": true, "isPriorityField": true },
    "ticketLogs.slaRemaining" : { "headerName": "SLA", "isSLAField" : true }
}

const mapStateToProps = (state: IState) => {
    return ({
        tickets: state?.AllTicketsReducer?.otherTickets,
        currAgent : state?.agentReducer?.loggedInAgent
    })
};

export default connect(mapStateToProps)(ListViewTable);